/** Bottom tab bar for phones. */
import { usePathname, useRouter } from 'expo-router'
import { Stack, Text, XStack, YStack } from 'tamagui'

import { useApp } from '../i18n'
import { Icon } from '../ui'
import { pressable } from '../ui/primitives'
import { NAV_TABS, isMoreRoute } from './nav'

export function BottomNav() {
  const router = useRouter()
  const pathname = usePathname()
  const { l } = useApp()
  const isActive = (route: string) => (route === '/' ? pathname === '/' : pathname.startsWith(route))
  return (
    <XStack height={60} flexShrink={0} borderTopWidth={1} borderColor="$borderSecondary" backgroundColor="$background">
      {NAV_TABS.map((it) => {
        // «Ещё» stays active for any section it hosts (/kb, /calendar, …), not just /more.
        const on = it.key === 'more' ? isMoreRoute(pathname) : isActive(it.route)
        return (
          <YStack
            key={it.key}
            {...pressable}
            flexGrow={1}
            flexBasis={0}
            minWidth={0}
            onPress={() => router.push(it.route)}
            cursor="pointer"
            alignItems="center"
            justifyContent="center"
            gap={3}
            paddingHorizontal={2}
            animation="quicker"
            pressStyle={{ scale: 0.9 }}
            role="link"
            aria-label={l('nav.' + it.key)}
          >
            {/* active tab pops with a spring (native) / smooth ease (web) */}
            <Stack animation="bouncy" scale={on ? 1.15 : 1} y={on ? -1 : 0}>
              <Icon name={it.icon} size={20} color={on ? '$primary' : '$muted'} />
            </Stack>
            <Text fontSize={10} fontWeight={on ? '600' : '400'} color={on ? '$primary' : '$muted'} numberOfLines={1}>
              {l('nav.' + it.key)}
            </Text>
          </YStack>
        )
      })}
    </XStack>
  )
}
